export const loadAppConfig = () => {
  if (
    !process.env.REACT_APP_VERSION ||
    !process.env.REACT_APP_CLIENT_ID ||
    !process.env.REACT_APP_USE_AUTH ||
    !process.env.REACT_APP_API_BASE_URL
  ) {
    throw Error("Missing Env");
  }

  const { REACT_APP_VERSION, REACT_APP_CLIENT_ID, REACT_APP_USE_AUTH, REACT_APP_API_BASE_URL } = process.env;

  return {
    REACT_APP_VERSION,
    REACT_APP_CLIENT_ID,
    REACT_APP_USE_AUTH: REACT_APP_USE_AUTH === "true",
    REACT_APP_API_BASE_URL,
  };
};
